import firebase from "firebase";

const firebaseConfig = {
	apiKey: "AIzaSyC3np8bfPfTgvxpBLy9-VxsdsTFsoddGsg",
	authDomain: "battle-of-quiz-be836.firebaseapp.com",
	databaseURL: "https://battle-of-quiz-be836-default-rtdb.firebaseio.com",
	projectId: "battle-of-quiz-be836",
	storageBucket: "battle-of-quiz-be836.appspot.com",
	messagingSenderId: "482041872937",
	appId: "1:482041872937:web:5aaee5f59e4ac584441238",
	measurementId: "G-QWMVN2WS9Y"
  };
  

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage()

export { db, auth, provider, storage };
